/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumBriefumschlag: {
    name: 'big-medium-briefumschlag';
    data: string;
} = {
    name: 'big-medium-briefumschlag',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M118 23H10a7 7 0 0 0-7 7v68a7 7 0 0 0 7 7h108a7 7 0 0 0 7-7V30a7 7 0 0 0-7-7M97.49 70.46a5 5 0 0 0-7.07 7.08L107.92 95H20.36l18.07-17.4a5 5 0 0 0-6.94-7.2L13 88.21V40.07l44.64 44.64a9 9 0 0 0 12.72 0L115 40.07v47.87zM20.07 33h87.86L64 76.93z"/></svg>`,
};
